<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
			<span class="visually-hidden">Loading...</span>
		</div>

		<div class="container flex-grow-1 container-p-y" v-if="!isLoading" style="padding-top: 0px !important;">
			<div v-if="!selectedTraining" class="row">
				<div class="col-md-12 mb-5" v-if="company">
					<div class="card h-100">
						<div class="card-body pb-4">
							<div class="mb-0">
								<div class="d-flex align-items-center">
									<div class="avatar avatar-md">
										<div class="avatar-initial bg-label-primary rounded-3">
											<i class="ri-bank-card-line ri-24px"></i>
										</div>
									</div>
									<div class="ms-4">
										<p class="mb-0">
											Vous avez actuellement <strong>{{company.credits}} crédits</strong>, ces crédits vous servent à commander les formations. 
											<br />
											Vous pouvez acheter des crédits sur votre compta Pika
											<router-link to="/purchase-credits">
												en cliquant ici
											</router-link>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-12 col-xxl-4 col-lg-4 pb-20" v-for="(training, index) in sortedTrainings" :key="index">
					<div class="card h-100">
						<img class="card-img-top" :src="training.previewUrl[0].url" alt="iPhone-bg" />
						<div class="card-body">
							<div class="row mb-6 g-6">
								<div class="col-6">
									<div class="d-flex">
										<div class="avatar flex-shrink-0 me-4">
											<span class="avatar-initial rounded-3 bg-label-primary"
												><i class="ri-calendar-line ri-24px"></i
											></span>
										</div>
										<div>
											<h6 class="mb-0 text-nowrap fw-normal">
												{{ training.validityInYears }} an{{ training.validityInYears > 1 ? 's' : '' }}
											</h6>
											<small>Validité</small>
										</div>
									</div>
								</div>
								<div class="col-6">
									<div class="d-flex">
										<div class="avatar flex-shrink-0 me-4">
											<span class="avatar-initial rounded-3 bg-label-primary"
												><i class="ri-time-line ri-24px"></i
											></span>
										</div>
										<div>
											<h6 class="mb-0 text-nowrap fw-normal">
												{{
													training.durationInHours < 1
													? Math.round(training.durationInHours * 60) + ' minute' + (Math.round(training.durationInHours * 60) > 1 ? 's' : '')
													: formatDuration(training.durationInHours)
												}}
											</h6>
											<small>Durée</small>
										</div>
									</div>
								</div>
							</div>
							<a 
								href="javascript:void(0);"
								class="btn btn-primary w-100"
								@click="selectTraining(training)"
								v-if="training.isAvailable"
							>
								Choisir cette formation ({{ training.price }} crédits)
							</a>
							<a href="javascript:void(0);" class="btn btn-label-secondary w-100" v-else disabled="true">
								Bientôt disponible
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="row" v-if="selectedTraining && !displayEmployees">
				<div class="col-12">
					<div class="card">
						<div
							class="card-header sticky-element bg-label-secondary d-flex justify-content-sm-between align-items-sm-center flex-column flex-sm-row">
							<h5 class="card-title mb-sm-0 me-2">Choisir le type de formation</h5>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-lg-8 mx-auto">

								<!-- 2. Delivery Type -->
									<h5 class="my-6">1. Type de formation</h5>
									<div class="row gy-3">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon1">
													<span class="custom-option-body">
														<i class="ri-play-circle-line"></i>
														<span class="custom-option-title mb-2"> Initiale </span>
														<small>
															Il s'agit de la toute première<br/>formation pour le salarié.
														</small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="initial"
														id="customRadioIcon1"
														v-model="selectedType"
														/>
												</label>
											</div>
										</div>
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon2">
													<span class="custom-option-body">
														<i class="ri-loop-left-line"></i>
														<span class="custom-option-title mb-2"> Périodique </span>
														<small>
															Il s'agit d'un renouvellement<br/>périodique de formation pour le salarié.
														</small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="renewal"
														id="customRadioIcon2"
														v-model="selectedType"
													/>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
						<div class="d-flex flex-column justify-content-center">
							
						</div>
						<div class="d-flex align-content-center flex-wrap gap-4 mt-5">
							<button class="btn btn-outline-secondary" @click="selectedTraining = null">Retour</button>
							<button type="submit" class="btn btn-primary" @click="showEmployees()" v-if="selectedType">Suivant</button>
							<button type="submit" class="btn btn-primary disabled" v-else>Suivant</button>
						</div>
					</div>
				</div>
			</div>

			<div class="row" v-if="displayEmployees">
				<div class="col-xs-12 col-12 col-lg-8 col-xl-8" v-if="selectedTraining">
					<div class="card card-action mb-5">
						<div class="card-header align-items-center">
							<h5 class="card-action-title mb-0">Choissiez un stagiaire pour la formation {{ displayType() }} {{ selectedTraining.title }}</h5>
						</div>
						<div class="card-body">
							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control dt-input dt-full-name"
									data-column="1"
									placeholder="11.2.6.2"
									data-column-index="0"
									v-model="search"
									@input="fetchEmployees"
									autocomplete="off"
								/>
								<label>Recherche par nom</label>
							</div>
								
							<ul class="list-unstyled mb-0">
								<li class="mb-4" v-for="(employee, index) in employees" :key="index">
									<div class="d-flex align-items-center">
										<div class="d-flex align-items-center">
											<div class="avatar me-2">
												<img :src="`https://ui-avatars.com/api/?name=${employee.firstName}+${employee.lastName}&background=666cff&color=fff`" alt="Avatar" class="rounded-circle" />
											</div>
											<div class="me-2">
												<h6 class="mb-1">{{ employee.firstName }} {{ employee.lastName }}</h6>
												<small>{{ employee.email }}</small>
											</div>
										</div>
										<div class="ms-auto">
											<button
												class="btn btn-icon"
												:class="isSelected(employee) ? 'btn-primary' : 'btn-outline-primary'"
												@click="toggleEmployeeSelection(employee)"
											>
												<i v-if="isSelected(employee)" class="ri-check-fill"></i>
												<i v-else class="ri-user-add-line ri-22px"></i>
											</button>
										</div>
									</div>
								</li>
								<li class="text-center">
									<button type="submit" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createEmployee">
										Ajouter un salarié
									</button>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="col-xs-12 col-12 col-xl-4">
					<div class="border rounded-4 p-5 mb-4">
						<h6>Détails du prix (formation {{ selectedTraining.title }})</h6>
						<dl class="row mb-0">
							<!-- Liste des employés avec v-for -->
							<template v-for="(employee) in selectedEmployees" :key="employee.id">
								<dt class="col-6 fw-normal text-muted">
									{{ employee.firstName }}
									{{ employee.lastName }}
								</dt>
								<!-- <dd class="col-6 text-end">✔️</dd> -->
								<dd class="col-6 text-end">{{ selectedTraining.price }} crédits</dd>
							</template>
						</dl>

						<hr class="mx-n5 my-5" />
						<dl class="row mb-0">
							<!-- <dt class="col-6 fw-normal text-heading">TVA</dt> -->
							<!-- <dd class="col-6 text-end">{{ taxes }}€</dd> -->
							<dt class="col-6 text-heading">Total</dt>
							<dd class="col-6 fw-medium text-heading text-end mb-0">{{ priceWithoutTaxes }} crédits</dd>
						</dl>
					</div>
					<div class="d-grid">
						<button class="btn btn-primary btn-next" @click="processTrainings()" v-if="selectedEmployees.length === 0" disabled>
							Commander
						</button>
						<button class="btn btn-primary btn-next" @click="processTrainings()" v-if="!isWaitingStripe && selectedEmployees.length > 0">
							Commander pour {{ priceWithoutTaxes }} crédits
						</button>
						<button class="btn btn-primary waves-effect waves-light" type="button" disabled="" v-if="isWaitingStripe">
							<span class="spinner-border me-1" role="status" aria-hidden="true"></span>
							Chargement...
						</button>
					</div>
				</div>
			</div>

			<div class="modal fade" id="createEmployee" tabindex="-1" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc">
					<div class="modal-content">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						<div class="modal-body p-0">
							<div class="text-center mb-6">
								<h4 class="mb-2">
									Ajouter un salarié
								</h4>
							</div>

							<form id="addTrainingForm" class="row g-5" onsubmit="return false">

								<div class="col-6">
									<div class="form-floating form-floating-outline">
										<input
											type="text"
											id="modalEditUserFirstName"
											name="modalEditUserFirstName"
											class="form-control"
											v-model="form.firstName" />
										<label for="modalEditUserFirstName">Prénom</label>
										<small v-if="errors.firstName" class="text-danger">{{ errors.firstName }}</small>
									</div>
								</div>

								<div class="col-6">
									<div class="form-floating form-floating-outline">
										<input
											type="text"
											id="modalEditUserLastName"
											name="modalEditUserLastName"
											class="form-control"
											v-model="form.lastName" />
										<label for="modalEditUserLastName">Nom</label>
										<small v-if="errors.lastName" class="text-danger">{{ errors.lastName }}</small>
									</div>
								</div>

								<div class="col-12">
									<div class="form-floating form-floating-outline">
										<input
											type="email"
											id="modalEditUserFirstName"
											name="modalEditUserFirstName"
											class="form-control"
											v-model="form.email" />
										<label for="modalEditUserFirstName">Email</label>
										<small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
									</div>
								</div>

								<div class="col-md-12 col-12">
									<div class="form-floating form-floating-outline">
										<input type="text" id="bs-datepicker-basic" placeholder="MM/DD/YYYY" class="form-control" @input="handleDateInput" v-model="form.birthDate" />
										<label for="bs-datepicker-basic">Date de naissance</label>
										<small v-if="errors.birthDate" class="text-danger">{{ errors.birthDate }}</small>
									</div>
								</div>

								<div class="col-12 d-flex flex-wrap justify-content-center gap-4 row-gap-4">
									<button type="submit" class="btn btn-primary" @click="createEmployee()">Enregistrer</button>
									<button
										type="reset"
										class="btn btn-outline-secondary btn-reset"
										data-bs-dismiss="modal"
										aria-label="Close">
										Cancel
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";


export default {
	name: "TrainingCreate",

	data() {
		return {
			search: null,
			company: null,
			taxes: 0,
			priceWithoutTaxes: 0,
			isLoading: true,
			selectedTraining: null,
			selectedType: null,
			displayEmployees: false,
			employees: [],
			selectedEmployees: [],
			trainings: [],
			isWaitingStripe: false,
			form: {
				firstName: "",
				lastName: "",
				email: "",
				birthDate: null,
				role: "trainee"
			},
			errors: {},
		};
	},

	methods: {
		formatDuration(hours) {
			const fullHours = Math.floor(hours)
			const minutes = Math.round((hours - fullHours) * 60)

			if (minutes === 0)
				return `${fullHours} heures`
				
			return `${fullHours}h${minutes}`
		},

		async fetchCompany() {
			try {
				const response = await HTTP('/company');
				this.company = response.data.company;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		getEmployeeFirstname(selectedId) {
			const employee = this.employees.find(emp => String(emp._id) === String(selectedId));
			return employee;
		},

		selectTraining(training) {
			this.selectedTraining = training;
		},

		showEmployees() {
			this.displayEmployees = true;
		},

		displayType() {
			if (this.selectedType === "renewal")
				return "périodique";
			
			return "initiale";
		},

		handleDateInput(event) {
			let input = event.target.value;

			// Enlever tous les caractères non numériques
			input = input.replace(/\D/g, '');

			// Formatage automatique en DD/MM/YYYY
			if (input.length <= 2) {
				this.form.birthDate = input;
			} else if (input.length <= 4) {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2)}`;
			} else {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
			}
		},

		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},

		validateForm() {
			this.errors = {};

			if (!this.form.firstName) {
				this.errors.firstName = "Le prénom est obligatoire.";
			}

			if (!this.form.lastName) {
				this.errors.lastName = "Le nom est obligatoire.";
			}

			if (!this.form.email || !this.validateEmail(this.form.email)) {
				this.errors.email = "Veuillez entrer une adresse e-mail valide.";
			}

			if (!this.form.birthDate) {
				this.errors.birthDate = "La date de naissance est obligatoire";
			}

			return Object.keys(this.errors).length === 0;
		},

		async createEmployee() {
			const validated = this.validateForm();

			if (!validated)
				return;

			if (!this.form.birthDate)
				delete this.form.birthDate;

			try {
				await HTTP.post('/company/employees/create', this.form);
				
				const modal = window.bootstrap.Modal.getInstance(document.getElementById("createEmployee"));
				if (modal) {
					modal.hide();
				}

				this.fetchEmployees();
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);
				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		isSelected(employee) {
			// Vérifie si l'employé est dans la liste des employés sélectionnés
			return this.selectedEmployees.some(e => e._id === employee._id);
		},

		toggleEmployeeSelection(employee) {
			// Ajoute ou retire l'employé de la liste des employés sélectionnés
			if (this.isSelected(employee)) {
				this.selectedEmployees = this.selectedEmployees.filter((e) => e._id !== employee._id);
			} else {
				this.selectedEmployees.push(employee);
			}

			this.calculatePrice();
			this.search = null;
			this.fetchEmployees();
		},

		calculatePrice() {
			if (!this.selectedTraining.price)
				this.selectedTraining.price = 0;

			this.priceWithoutTaxes = (this.selectedEmployees.length * this.selectedTraining.price);

			// Arrondir les valeurs à 2 décimales
			this.priceWithoutTaxes = parseFloat(this.priceWithoutTaxes.toFixed(2));
		},

		async processTrainings() {
			this.isWaitingStripe = true;

			try {
				await HTTP.post('/trainings/assign-an-employee', {
					employeesIds: this.selectedEmployees.map(e => e._id),
					formationName: this.selectedTraining.formationName,
					type: this.selectedType
				});

				this.$router.push("/trainings/success");
			} catch (error) {
				this.isWaitingStripe = false;

				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async processCheckout() {
			this.isWaitingStripe = true;

			try {
				const rep = await HTTP.post('/trainings/process-checkout', {
					employeesIds: this.selectedEmployees.map(e => e._id),
					formationName: this.selectedTraining.formationName,
					type: this.selectedType
				});

				window.location.replace(rep.data.url);
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async registerToTraining(employeeId, formationName) {
			try {
				await HTTP.post('/trainings/assign-an-employee', {
					employeeId,
					formationName
				});
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async fetchEmployees() {
			try {
				const response = await HTTP('/company/employees', { params: { limit: 50, search: this.search } });
				this.employees = response.data.employees;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async fetchTrainings() {
			try {
				const response = await HTTP('/trainings');
				this.trainings = response.data.formations;
				this.isLoading = false;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},
	},

	async mounted() {
		this.fetchCompany();
		this.fetchTrainings();
		this.fetchEmployees();
	},

	computed: {
		sortedTrainings() {
			// Trie les formations par `order`
			return [...this.trainings].sort((a, b) => a.order - b.order);
		}
	}
};
</script>

<style scoped>
.load-center {
	display: block;
	margin: 0 auto;
}

/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.modal-simple .modal-content {
	padding: 3rem;
}

.pb-20 {
	padding-bottom: 20px;
}
</style>
